.bv__rating {
  padding-top: 10px;
  box-sizing: border-box;
  display: block;
}

.bv__rating *,
.bv__rating *::before,
.bv__rating *::after {
  box-sizing: inherit;
}